module.exports = __webpack_public_path__ + "static/img/ALBB.33d5ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ALBB.png
// module id = 1T3G
// module chunks = 34